module.exports = __webpack_public_path__ + "static/media/sucess_order_delivery.49c7dd11.svg";